import { SOIL_SIGHT_FLOW_ROUTES, type SoilSightFlowRoute } from "consts";

import { SoilSightOnboardingAccess } from "pages/app/scenario-onboarding/hooks/useSoilSightOnboardingAccess";

/** Entry point for a user who still has to onboard: the landing is skipped once it was passed. */
export const resolveOnboardingEntryRoute = (hasPassedLanding: boolean): SoilSightFlowRoute =>
  hasPassedLanding ? SOIL_SIGHT_FLOW_ROUTES.onboardingStep1 : SOIL_SIGHT_FLOW_ROUTES.landing;

/**
 * The one page the flow belongs on for this user, so every gate applies the same rule instead of
 * repeating it per route. Null while access is still resolving — nothing may be decided yet.
 */
export const resolveSoilSightFlowRoute = (access: SoilSightOnboardingAccess): SoilSightFlowRoute | null => {
  if (access.isLoading) return null;
  if (access.isAllowed) return SOIL_SIGHT_FLOW_ROUTES.scenarios;
  return resolveOnboardingEntryRoute(access.hasPassedLanding);
};
